<!-- Empty state -->
<div *ngIf="!listaCuentas || listaCuentas.length === 0"
  style="text-align: center; padding: 48px 20px;">
  <mat-icon style="font-size: 48px; width: 48px; height: 48px; color: #d1d5db; margin-bottom: 12px;">people_outline</mat-icon>
  <p style="font-size: 0.95rem; color: #6b7280; margin: 0;">No tienes beneficiarios registrados</p>
</div>

<!-- Contenido con datos -->
<ng-container *ngIf="listaCuentas && listaCuentas.length > 0">

  <!-- ═══ TABLA DESKTOP ═══ -->
  <div class="hidden lg:block" style="background: white; border-radius: 16px; border: 1px solid #e5e7eb; overflow: hidden; box-shadow: 0 2px 8px rgba(0,0,0,0.06);">

    <table mat-table [dataSource]="listaCuentas" style="width: 100%;">

      <!-- Nombre -->
      <ng-container matColumnDef="nombre">
        <th mat-header-cell *matHeaderCellDef>Beneficiario</th>
        <td mat-cell *matCellDef="let cuenta" style="font-weight: 600; color: #111827;">
          <div class="flex items-center gap-2">
            <div style="width: 32px; height: 32px; border-radius: 50%; background: linear-gradient(135deg, #f0fdf4, #d1fae5); display: flex; align-items: center; justify-content: center; flex-shrink: 0;">
              <mat-icon style="font-size: 16px; width: 16px; height: 16px; color: #1C593D;">{{ cuenta.tipoBeneficiarioId === 0 ? 'person' : 'business' }}</mat-icon>
            </div>
            <div>
              <span>{{ cuenta.nombre }} {{ cuenta.tipoBeneficiarioId === 0 ? cuenta.apellidos : '' }}</span>
              <div style="font-size: 0.7rem; font-weight: 400; color: #9ca3af;">
                {{ cuenta.tipoBeneficiarioId === 0 ? 'Persona' : 'Empresa' }}
              </div>
            </div>
          </div>
        </td>
      </ng-container>

      <!-- Banco -->
      <ng-container matColumnDef="banco">
        <th mat-header-cell *matHeaderCellDef>Banco</th>
        <td mat-cell *matCellDef="let cuenta" style="color: #374151;">
          {{ cuenta.banco?.nombre | titlecase }}
        </td>
      </ng-container>

      <!-- Tipo Cuenta -->
      <ng-container matColumnDef="tipoCuenta">
        <th mat-header-cell *matHeaderCellDef>Tipo Cuenta</th>
        <td mat-cell *matCellDef="let cuenta">
          <span *ngIf="cuenta.movilPay === 1"
            style="display: inline-block; padding: 2px 10px; border-radius: 6px; font-size: 0.75rem; font-weight: 600; background: #fef3c7; color: #92400e;">
            Movil Pay
          </span>
          <span *ngIf="cuenta.movilPay !== 1" style="color: #374151;">
            {{ cuenta.tipoCuenta?.nombre }}
          </span>
        </td>
      </ng-container>

      <!-- Número Cuenta -->
      <ng-container matColumnDef="numeroCuenta">
        <th mat-header-cell *matHeaderCellDef>Nº Cuenta</th>
        <td mat-cell *matCellDef="let cuenta" style="font-family: monospace; font-weight: 600; color: #2563eb; font-size: 0.85rem;">
          {{ cuenta.movilPay === 1 ? '(+58) ' + cuenta.numeroCuenta : cuenta.numeroCuenta }}
        </td>
      </ng-container>

      <!-- Acciones -->
      <ng-container matColumnDef="acciones">
        <th mat-header-cell *matHeaderCellDef style="text-align: center;">Acciones</th>
        <td mat-cell *matCellDef="let cuenta" style="text-align: center;">
          <div class="flex items-center justify-center gap-2">
            <!-- Ver -->
            <button type="button" (click)="verCuenta(cuenta); $event.stopPropagation()"
              title="Ver detalle"
              style="width: 30px; height: 30px; border-radius: 6px; border: 1px solid #bfdbfe; background: #eff6ff; cursor: pointer; display: flex; align-items: center; justify-content: center; transition: background 0.2s ease;"
              onmouseover="this.style.background='#dbeafe'" onmouseout="this.style.background='#eff6ff'">
              <mat-icon style="font-size: 16px; width: 16px; height: 16px; color: #2563eb; flex-shrink: 0;">visibility</mat-icon>
            </button>
            <!-- Editar -->
            <button type="button" (click)="actualizar(cuenta); $event.stopPropagation()"
              title="Editar"
              style="width: 30px; height: 30px; border-radius: 6px; border: 1px solid #bfdbfe; background: #eff6ff; cursor: pointer; display: flex; align-items: center; justify-content: center; transition: background 0.2s ease;"
              onmouseover="this.style.background='#dbeafe'" onmouseout="this.style.background='#eff6ff'">
              <mat-icon style="font-size: 16px; width: 16px; height: 16px; color: #2563eb; flex-shrink: 0;">edit</mat-icon>
            </button>
            <!-- Eliminar -->
            <button type="button" (click)="inactivarCuenta(cuenta); $event.stopPropagation()"
              title="Eliminar"
              style="width: 30px; height: 30px; border-radius: 6px; border: 1px solid #fecaca; background: #fef2f2; cursor: pointer; display: flex; align-items: center; justify-content: center; transition: background 0.2s ease;"
              onmouseover="this.style.background='#fee2e2'" onmouseout="this.style.background='#fef2f2'">
              <mat-icon style="font-size: 16px; width: 16px; height: 16px; color: #dc2626; flex-shrink: 0;">delete</mat-icon>
            </button>
          </div>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"
        (click)="seleccionar(row)"
        [style.cursor]="seleccionable ? 'pointer' : 'default'"
        [style.background]="row.seleccionado ? '#f0fdf4' : ''"></tr>
    </table>

  </div>

  <!-- ═══ CARDS MOBILE ═══ -->
  <div class="lg:hidden flex flex-col gap-3">
    <div *ngFor="let cuenta of listaCuentas"
      (click)="seleccionar(cuenta)"
      [style.cursor]="seleccionable ? 'pointer' : 'default'"
      style="background: white; border-radius: 12px; border: 1px solid #e5e7eb; overflow: hidden; box-shadow: 0 1px 4px rgba(0,0,0,0.04);"
      [style.border-color]="cuenta.seleccionado ? '#34d399' : '#e5e7eb'">

      <!-- Card header clickable -->
      <div (click)="toggleCard(cuenta.cuentaBeneficiarioID); $event.stopPropagation()"
        style="padding: 14px 16px; display: flex; align-items: center; justify-content: space-between; cursor: pointer;"
        [style.background]="expandedCardId === cuenta.cuentaBeneficiarioID ? 'linear-gradient(135deg, #f0fdf4, #ecfdf5)' : 'white'">
        <div class="flex items-center gap-3" style="min-width: 0; flex: 1;">
          <div style="width: 36px; height: 36px; border-radius: 50%; background: linear-gradient(135deg, #f0fdf4, #d1fae5); display: flex; align-items: center; justify-content: center; flex-shrink: 0;">
            <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: #1C593D;">{{ cuenta.tipoBeneficiarioId === 0 ? 'person' : 'business' }}</mat-icon>
          </div>
          <div style="min-width: 0;">
            <div style="font-weight: 700; font-size: 0.88rem; color: #111827; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">
              {{ cuenta.nombre }} {{ cuenta.tipoBeneficiarioId === 0 ? cuenta.apellidos : '' }}
            </div>
            <div style="font-size: 0.75rem; color: #6b7280;">
              {{ cuenta.banco?.nombre | titlecase }}
            </div>
          </div>
        </div>
        <mat-icon style="font-size: 20px; width: 20px; height: 20px; color: #9ca3af; flex-shrink: 0; transition: transform 0.2s ease;"
          [style.transform]="expandedCardId === cuenta.cuentaBeneficiarioID ? 'rotate(180deg)' : 'rotate(0)'">
          expand_more
        </mat-icon>
      </div>

      <!-- Card body expandible -->
      <div *ngIf="expandedCardId === cuenta.cuentaBeneficiarioID"
        style="padding: 0 16px 14px; border-top: 1px solid #e5e7eb;">

        <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 10px; padding-top: 12px;">
          <div>
            <span style="font-size: 0.68rem; font-weight: 600; color: #9ca3af; text-transform: uppercase;">Tipo</span>
            <p style="margin: 1px 0 0; font-size: 0.82rem; font-weight: 600; color: #374151;">
              {{ cuenta.tipoBeneficiarioId === 0 ? 'Persona' : 'Empresa' }}
            </p>
          </div>
          <div>
            <span style="font-size: 0.68rem; font-weight: 600; color: #9ca3af; text-transform: uppercase;">Tipo Cuenta</span>
            <p style="margin: 1px 0 0; font-size: 0.82rem; font-weight: 600; color: #374151;">
              {{ cuenta.movilPay === 1 ? 'Movil Pay' : cuenta.tipoCuenta?.nombre }}
            </p>
          </div>
          <div style="grid-column: span 2;">
            <span style="font-size: 0.68rem; font-weight: 600; color: #9ca3af; text-transform: uppercase;">
              {{ cuenta.movilPay === 1 ? 'Teléfono' : 'Nº Cuenta' }}
            </span>
            <p style="margin: 1px 0 0; font-size: 0.85rem; font-weight: 700; color: #2563eb; font-family: monospace;">
              {{ cuenta.movilPay === 1 ? '(+58) ' + cuenta.numeroCuenta : cuenta.numeroCuenta }}
            </p>
          </div>
        </div>

        <!-- Acciones mobile -->
        <div class="flex items-center gap-2" style="margin-top: 12px; padding-top: 12px; border-top: 1px solid #f3f4f6;">
          <button type="button" (click)="verCuenta(cuenta); $event.stopPropagation()"
            style="flex: 1; display: flex; align-items: center; justify-content: center; gap: 4px; padding: 8px; background: #eff6ff; border: 1px solid #bfdbfe; border-radius: 8px; cursor: pointer; font-size: 0.75rem; font-weight: 600; color: #2563eb; transition: background 0.2s ease;"
            onmouseover="this.style.background='#dbeafe'" onmouseout="this.style.background='#eff6ff'">
            <mat-icon style="font-size: 15px; width: 15px; height: 15px; flex-shrink: 0;">visibility</mat-icon>
            Ver
          </button>
          <button type="button" (click)="actualizar(cuenta); $event.stopPropagation()"
            style="flex: 1; display: flex; align-items: center; justify-content: center; gap: 4px; padding: 8px; background: #eff6ff; border: 1px solid #bfdbfe; border-radius: 8px; cursor: pointer; font-size: 0.75rem; font-weight: 600; color: #2563eb; transition: background 0.2s ease;"
            onmouseover="this.style.background='#dbeafe'" onmouseout="this.style.background='#eff6ff'">
            <mat-icon style="font-size: 15px; width: 15px; height: 15px; flex-shrink: 0;">edit</mat-icon>
            Editar
          </button>
          <button type="button" (click)="inactivarCuenta(cuenta); $event.stopPropagation()"
            style="flex: 1; display: flex; align-items: center; justify-content: center; gap: 4px; padding: 8px; background: #fef2f2; border: 1px solid #fecaca; border-radius: 8px; cursor: pointer; font-size: 0.75rem; font-weight: 600; color: #dc2626; transition: background 0.2s ease;"
            onmouseover="this.style.background='#fee2e2'" onmouseout="this.style.background='#fef2f2'">
            <mat-icon style="font-size: 15px; width: 15px; height: 15px; flex-shrink: 0;">delete</mat-icon>
            Eliminar
          </button>
        </div>

      </div>
    </div>
  </div>

</ng-container>
